var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 40,
    viewBox: "0 0 200 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8392 34.9654H81.6283L87.2101 17.4524H87.2767L92.8511 34.9684H97.8206L105.216 9.66389H99.5658L95.321 26.3161H95.2486L89.9936 9.66093H84.8082L79.5251 25.8828H79.4512L75.4105 9.66093H69.3347L76.8392 34.9654ZM109.636 22.3124C109.636 30.4234 115.39 35.6014 123.291 35.6014C131.192 35.6014 136.939 30.4248 136.939 22.3124C136.939 14.2 131.189 9.022 123.291 9.022C115.393 9.022 109.636 14.1986 109.636 22.3169V22.3124ZM115.427 22.3124C115.427 17.5914 118.533 14.1571 123.291 14.1571C128.049 14.1571 131.147 17.5914 131.147 22.3124C131.147 27.0335 128.041 30.4618 123.291 30.4618C118.54 30.4618 115.427 27.0261 115.427 22.3124ZM143.641 34.9654H149.222V24.8475H151.969L157.259 34.9639H163.947L157.515 24.2736C161.084 23.6302 162.988 20.8837 162.988 17.337C162.988 11.4417 158.624 9.66093 153.44 9.66093H143.641V34.9654ZM149.222 14.3746H152.867C154.902 14.3746 157.191 14.7709 157.191 17.3074C157.191 20.0614 154.542 20.1279 152.507 20.1279H149.222V14.3746ZM199.606 30.6704H192.528V30.6023C195.992 29.0627 197.557 25.5604 197.557 21.9915C197.557 14.3746 191.556 9.01756 184.052 9.01756C176.547 9.01756 170.539 14.342 170.539 21.9915C170.539 30.1394 176.368 34.9654 184.262 34.9654H199.601L199.606 30.6704ZM176.336 21.9915C176.336 17.6284 179.801 14.1527 184.058 14.1527C188.314 14.1527 191.78 17.624 191.78 21.9915C191.78 26.359 188.308 29.817 184.058 29.817C179.807 29.817 176.336 26.3457 176.336 21.9915Z",
    fill: "#2D2B30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0321 39.8003L16.0117 13.7741L28.2299 1.55592L48.4406 21.7682L42.0321 39.8003Z",
    fill: "#3F25F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2009 19.7582L43.4165 13.9737L56.8741 0.516174L49.2009 19.7582Z",
    fill: "#160AB4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8271 39.8003L0 0.516174L12.9133 13.4398L27.0497 27.5763L14.8271 39.8003Z",
    fill: "#A39EF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199.607,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logo-main.2b6e51e6b6eafda670dfa821c9735009.svg";
export { ForwardRef as ReactComponent };